import React from 'react';
import { Divider as MuiDivider } from '@material-ui/core';

const Divider = props => <MuiDivider {...props} />;

export default Divider;
